//-------------------------------------------------------------------------------------------------- Imports
import { Button, Card, Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ResponseMobilePhoneDataMobilePhone } from "../../../types/common";
import { useSelector } from "react-redux";
import { getAssetsConfigData } from "../../../stores/slices/assetsConfigSlice";

//-------------------------------------------------------------------------------------------------- Intefaces
interface PhonesListProps {
    phonesList: ResponseMobilePhoneDataMobilePhone[];
    onDetailClickElement: Function;
    onRechargeClickElement: Function;
};

export interface OnClickElementProps {
    phone: string;
    name: string;
};

//-------------------------------------------------------------------------------------------------- Component
const PhonesList = (props: PhonesListProps) => {
    const { phonesList, onDetailClickElement, onRechargeClickElement } = props;
    const assetsConfig = useSelector(getAssetsConfigData);
    return (
        <>
            {phonesList.map((phone, key: number) => (
                <Card key={key} style={styles.cardStyles} bodyStyle={{ padding: "15px 30px 15px 30px" }}>
                    <Row justify={"center"} align={"middle"}>
                        <Col sm={24} lg={12} xl={16} xxl={16}>
                            <Row style={styles.rowStyle}>
                                <h2 style={styles.hStyles}>Teléfono {key + 1}</h2>
                                <h4 style={styles.hStyles}>{phone.ani}</h4>
                            </Row>
                        </Col>
                        <Col sm={24} lg={12} xl={8} xxl={5}>
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    <Button
                                        block
                                        style={styles.buttonStyle}
                                        onClick={() => onDetailClickElement({
                                            name: `Teléfono ${key + 1}`,
                                            phone: phone.ani
                                        } as OnClickElementProps)}
                                    >
                                        Consultar
                                    </Button>
                                </Col>
                                {(assetsConfig.showRecargas) && (
                                    <Col span={24}>
                                        <Button
                                            block
                                            style={styles.buttonStyle}
                                            onClick={() => onRechargeClickElement(phone.ani)}
                                        >
                                            Recargar
                                        </Button>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </Card>
            ))}
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardStyles: {
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15
    },
    rowStyle: {
        display: "flex",
        height: "100%",
        flexDirection: "column",
        justifyContent: "center",
    },
    hStyles: {
        margin: 0,
    },
    buttonStyle: {
        textAlign: "center",
        fontSize: 14,
        fontWeight: 600,
        borderRadius: 20,
        border: "none",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    buttonContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default PhonesList;